const cmsPagesConstantsEn = {
  cmsPagesTitle: 'Pages',
  cmsPagesBreadcrumbs: 'Pages',
  cmsPagesTermsAndConditions: 'Terms and Conditions',
  cmsPagesPrivacyPolicy: 'Privacy Policy and Cookies Policy',
  cmsPagesCookiesPolicy: 'Cookies Policy',
  cmsPagesFaq: 'FAQs',
  cmsPagesSuccessStories: 'Success Stories',
  cmsPagesSuccessStoriesBreadcrumb: 'SUCCESS STORIES',
  cmsPagesBlogs: 'Blogs',
  cmsPagesAboutUs: 'About Us',
  cmsCheckoutTermsAndConditions: 'Checkout Terms and Conditions',
};

export default cmsPagesConstantsEn;
